import { tt, type HubTab } from '@agos/shared'

/**
 * *Platby online - archív*, as two tabs - FRONTEND.md §9.749, owner O121.
 *
 * The owner: *"rozvozar Jožko bral obj 78 qr platba (úspešná) suma 20€ / 68 cardpay suma 10€ / A dole súhrn"* - a
 * per-driver check beside the archive rather than a new sidebar entry. This is §9.302's shape (*Delivery hub*):
 * `visibleTabs`, `activeTab` and `stripIsWorthDrawing` from `@agos/shared`, and the tab in `?tab=`.
 *
 * **One route, two tabs, and that is the difference from the hubs.** `DELIVERY_TABS` and `EXTERNAL_COMPANY_TABS` fold
 * two routes into one screen, so each tab carries the route it draws. Here both tabs draw `/online-payments` - the
 * per-driver check has no route of its own and needs none, because it is reached from the archive and only by the
 * people the archive's whole right admits.
 *
 * **The guards, and why they differ.**
 * - *Transakcie* shows to **everybody the route admits**. The route is `anyPermission: ['online_payments',
 *   'online_payments_view']`, which a tab's guard cannot express - `TabGuard` has one `permission` - so this tab names
 *   the route's module and no permission, and the route is what keeps out somebody holding neither. Gating it on
 *   either permission alone would take the archive away from the holders of the other.
 * - *Podľa rozvozárov* is the archive's **whole** right, `online_payments`, exactly as `GET /payments/by-driver` is
 *   guarded (BACKEND.md §10A.403, owner question #159): not `_view`, which Šurany's waiters and cooks hold, because the
 *   answer names colleagues beside money the gateway does not have.
 *
 * So a `_view` holder has one tab, sees no strip and an unchanged page, and a forwarded `?tab=drivers` falls back to
 * the archive - `activeTab`'s own rule for a tab the reader cannot see.
 */

/** The archive - today's page, unchanged. First, so it is what opens by default. */
export const ARCHIVE_TAB = 'payments'

/** *Podľa rozvozárov* - each driver's orders checked against the gateway. */
export const DRIVERS_TAB = 'drivers'

export const ONLINE_PAYMENTS_TABS: readonly HubTab[] = [
  {
    id: ARCHIVE_TAB,
    label: tt('Transakcie'),
    path: '/online-payments',
    guard: { franchiseModule: 'online_payments' },
  },
  {
    id: DRIVERS_TAB,
    label: tt('Podľa rozvozárov'),
    path: '/online-payments',
    guard: { permission: 'online_payments', franchiseModule: 'online_payments' },
  },
]
